export function OperationInspectorEdge({
  edgeType,
  source,
  sourceHandle,
  target,
  targetHandle
}: {
  edgeType: string;
  source: string;
  sourceHandle: string | null | undefined;
  target: string;
  targetHandle: string | null | undefined;
}) {
  return (
    <div className="reportSection">
      <div className="field">
        <label className="label">Edge type</label>
        <div className="muted">{edgeType}</div>
      </div>
      <div className="field">
        <label className="label">From</label>
        <div className="muted">
          {source} / {sourceHandle}
        </div>
      </div>
      <div className="field">
        <label className="label">To</label>
        <div className="muted">
          {target} / {targetHandle}
        </div>
      </div>
    </div>
  );
}
